import {AppTrackingTransparency} from 'capacitor-plugin-app-tracking-transparency'
import finBrowser from "@/js/finBrowser"
import {Capacitor} from "@capacitor/core"
import {FirebaseAnalytics} from "@capacitor-community/firebase-analytics"

export default {
  //TODO do this as Vue plugin method
  methods: {
    /** The object contains event, step, placement, vue_breakpoint, etc.
     * See https://collaboration.content-software.com:8090/display/FIN/Tracking
     * Example:
     {
          'event': 'fincraft_finhub_portfolios_new',
          'step': 'new_portfolio',
          'placement': 'finhub_portfolios',
          'vue_breakpoint': this.$vuetify.breakpoint.name
        } */
    async pushToAmplitude(object) {
      console.log('object', object)
      if (process.env.VUE_APP_TRACKING_TO_AMPLITUDE_ENABLED === 'true') {
        if (finBrowser.IS_IOS_APP && await this.getTrackingStatus().status === 'denied') {
          return
        }
        if (finBrowser.IS_IOS_OR_ANDROID_APP) {
          await this.pushToFirebase(object)
        } else {
          try {
            window.dataLayer.push({
              ...object, application: Capacitor.getPlatform()
            })
          } catch (e) {
            console.error("window.dataLayer.push error", e)
          }
        }
      } else {
        console.debug('disabled datalayer event', object)
      }
    }, async getTrackingStatus() {
      const response = await AppTrackingTransparency.getStatus()
      return response
    }, async pushToFirebase(object) {
      try {
        await FirebaseAnalytics.logEvent({
          name: object.event, params: {
            ...object, application: Capacitor.getPlatform()
          },
        })
      } catch (e) {
        console.error("firebase.push error", e)
      }
    }
  }
}
